import moment from "moment";

export const DATE_FORMATS = {
  /** 12/31/2024 */
  SHORT_DATE: "MM/DD/YYYY",
  /** 12/31/2024, 11:59:59 PM */
  FULL_DATETIME: "MM/DD/YYYY, h:mm:ss a",
  /** 12/31/2024, 11:59 PM */
  FULL_DATETIME_NO_SECONDS: "MM/DD/YYYY, h:mm A",
  /** 11:59 PM */
  TIME_ONLY: "h:mm a",
  /** 12-31-2024 */
  DASHED_DATE: "MM-DD-YYYY",
  /** 2024-12-31T11:59:59 */
  ISO_DATETIME: "YYYY-MM-DDTHH:mm:ss",
} as const;

type OptionsProps = {
  format: (typeof DATE_FORMATS)[keyof typeof DATE_FORMATS];
  utc?: boolean;
  reverse?: boolean;
};
export function getFormattedDate(
  date: string | Date | number | null | moment.Moment,
  options: OptionsProps,
): string | null {
  if (!date) return null;

  try {
    let formattedDate = moment(date, true);

    if (options.utc) formattedDate = formattedDate.local().utc();

    if (options.reverse) formattedDate = formattedDate.utc(true).local();

    if (!formattedDate.isValid()) return null;

    return formattedDate.format(options.format);
  } catch (error) {
    return null;
  }
}
